import { useContext } from 'react'
import TableContext from '../contexts/table-context'

const useTableContext = () => useContext(TableContext)

export default useTableContext
